import { Funnel, Plus, TrashSimple, Scroll, Pencil } from "phosphor-react";
import Tooltip from "components/common/tooltip";
import {
  capitalizeName,
  formatString,
  highlightFirstMatch,
} from "utils/common";
import CustomModal from "components/common/modal";
import AddReferralsList from "./AddReferralsList";
import AddFormWithoutMember from "./AddFromWithoutMember";
import { useNavigate } from "react-router-dom";
import AddQuestionForm from "components/members/Addmemberform";
import { createMember } from "containers/members/api";
import { deleteBulkReferral } from "containers/referrals/api";
import FilterReferral from "./FilterReferral";
import { REFERRALS_COLUMNS } from "constants/referrals";
const { default: TableWrapper } = require("components/common/table-wrapper");
const { initialMetaForTable, DEBOUNCE_DELAY } = require("constants/common");
const { getReferrals, createReferral } = require("containers/referrals/api");
const { useState, useCallback, useEffect } = require("react");
let timeout;

const ReferralsList = () => {
  const navigate = useNavigate();

  const [referralsList, setreferralsList] = useState([]);
  const [selectedReferral, setSelectedReferral] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedReferralIds, setSelectedReferralIds] = useState([]);
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
  });
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  const [loading, setLoading] = useState(true);
  const [selectedreferrals, setSelectedreferrals] = useState(0);
  const [isreferralAddModalVisible, setreferralIsModalVisible] = useState(
    false
  );

  const [refreshPage, setRefreshPage] = useState(false);
  const [addNewMemberModal, setAddNewMemberModal] = useState(false);
  const [FilterReferrals, setFilterReferrals] = useState(false);
  const [filters, setFilters] = useState({
    county: null,
    referral_programe: null,
    health_plan_id: null,
    referral_status: ["submitted", "pending"],
  });
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }));
    debounceFn(handleRefreshPage, DEBOUNCE_DELAY);
  };
  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }));
    handleRefreshPage();
  };
  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setreferralsList((prevList) =>
      prevList.map((item) => ({ ...item, checked: newSelectAll }))
    );
    if (newSelectAll) {
      const currentPageIds = referralsList.map((referral) => referral.id);
      setSelectedReferralIds((prev) => [
        ...new Set([...prev, ...currentPageIds]),
      ]);
    } else {
      const currentPageIds = referralsList.map((referral) => referral.id);
      setSelectedReferralIds((prev) =>
        prev.filter((id) => !currentPageIds.includes(id))
      );
    }
  };

  const handleCheckboxChange = (index) => {
    const referralId = referralsList[index].id;
    setreferralsList((prevList) =>
      prevList.map((item, itemIndex) =>
        itemIndex === index ? { ...item, checked: !item.checked } : item
      )
    );
    setSelectedReferralIds((prev) => {
      if (prev.includes(referralId)) {
        return prev.filter((id) => id !== referralId);
      } else {
        return [...prev, referralId];
      }
    });
  };

  const fetchReferrals = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getReferrals({
        ...meta,
        ...filters,
        key: sortConfig.key,
        order: sortConfig.direction,
      });
      if (result["referrals"]) {
        const data = result?.referrals.map((item) => ({
          ...item,
          checked: selectAll || selectedReferralIds.includes(item.id),
        }));
        setreferralsList(data);
        setTotalCount(result?.meta.total_count);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPage, filters, selectAll, sortConfig.direction, sortConfig.key]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const SortableTableHeader = ({
    columnKey,
    label,
    sortConfig,
    onSortChange,
  }) => {
    const isSorting = sortConfig.key === columnKey;
    const isAscending = isSorting && sortConfig.direction === "asc";
    const isDescending = isSorting && sortConfig.direction === "desc";

    const handleSort = () => {
      if (isAscending) {
        onSortChange(columnKey, "desc");
      } else {
        onSortChange(columnKey, "asc");
      }
    };

    return (
      <th onClick={handleSort} style={{ cursor: "pointer" }}>
        <div className="d-flex position-relative">
          <div className="d-flex flex-column cursor-pointer me-2 position-absolute top-50  end-100 translate-middle-y ">
            {/* <CaretUp size={12} color={isAscending ? '#000000' : '#00000050'} weight="fill" />
            <CaretDown color={isDescending ? '#000000' : '#00000050'} size={12} weight="fill" /> */}
          </div>
          <div>{label}</div>
        </div>
      </th>
    );
  };
  useEffect(() => {
    fetchReferrals();
  }, [fetchReferrals]);
  useEffect(() => {
    setSelectedreferrals(selectedReferralIds.length);
  }, [selectedReferralIds]);

  const handleApplyFilters = (newFilters) => {
    setFilters(newFilters);
    handleCloseFilterReferral();
  };

  const handleOpenAddModad = () => {
    setreferralIsModalVisible(true);
  };
  const handleCloseAddModal = () => {
    setreferralIsModalVisible(false);
    setSelectedReferral("");
  };
  const handleOpenAddReferralModal = () => {
    setAddNewMemberModal(true);
  };
  const handleCloseAddMemberModal = () => {
    setAddNewMemberModal(false);
  };
  const handleOpenFilterReferral = () => {
    setFilterReferrals(true);
  };
  const handleCloseFilterReferral = () => {
    setFilterReferrals(false);
  };
  const handleAddNewMember = async (values, setErrors = () => {}) => {
    const result = await createReferral(values, setErrors);
    if (result) {
      handleCloseAddMemberModal();
      handleRefreshPage();
    }
  };
  const handleDeleteBulkReferral = async () => {
    const payload = {
      ids: selectedReferralIds,
    };
    const result = await deleteBulkReferral(payload);
    if (result) {
      setSelectedReferralIds([]);
      setSelectAll(false);
      handleRefreshPage();
    }
  };
  // const handleSetReferralStatusFilter = (selectedValue) => {
  //   setMeta((prevMeta) => ({ ...prevMeta, referral_status: selectedValue }));
  //   handleRefreshPage();
  // };
  console.log("selectedReferral-----", selectedReferral);

  return (
    <>
      <TableWrapper
        searchPlaceholder="Search Referral"
        setSearhQuery={handleSetSearchQuery}
        searchValue={meta.search}
        totalListCount={totalCount}
        pageSize={meta.perPage}
        currentPage={meta.page}
        onPageChange={handlePageChange}
        isLoading={loading}
        selectedItems={selectedreferrals}
        upload={true}
        uploadKey={"Referral"}
        actionButtons={
          selectedreferrals > 0
            ? [
                {
                  label: `Delete ${selectedreferrals} Items`,
                  classes: "danger-btn m-0-imp",
                  icon: <TrashSimple size={24} className="me-3" />,
                  handleClick: handleDeleteBulkReferral,
                },
              ]
            : [
                {
                  label: "Filter Referral",
                  classes: "primary-btn",
                  icon: <Funnel size={24} className="me-3" />,
                  handleClick: () => {
                    handleOpenFilterReferral();
                  },
                },
                {
                  label: "Add Referral",
                  classes: "primary-btn",
                  icon: <Plus size={24} className="me-3" />,
                  handleClick: () => {
                    handleOpenAddModad();
                  },
                },
              ]
        }
      >
        <div className="container-fluid">
          <div className="table-responsive scrollable">
            <table className="table table-rows">
              <thead className="table-header">
                <tr>
                  <th>
                    <div className="form-check ps-3 mb-0">
                      <input
                        className="form-check-input light-grey-background"
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                  {REFERRALS_COLUMNS.map((column) => (
                    <SortableTableHeader
                      key={column.columnKey}
                      columnKey={column.columnKey}
                      label={column.label}
                      isSortable={column.isSortable}
                      sortConfig={sortConfig}
                      onSortChange={handleSort}
                    />
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {referralsList?.map((referral, index) => (
                  <tr key={index}>
                    <td>
                      <div className="form-check ps-3 mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={referral.checked}
                          onChange={() => handleCheckboxChange(index)}
                          value=""
                        />
                      </div>
                    </td>
                    <td>
                      {highlightFirstMatch(
                        capitalizeName(referral.member.name),
                        meta.search
                      )}
                    </td>

                    <td>
                      {highlightFirstMatch(referral.member.cin, meta.search)}
                    </td>
                    <td>{referral.member.date_of_birth || "-"}</td>
                    <td>
                      {capitalizeName(referral.member?.county?.name) || "-"}
                    </td>
                    <td>{formatString(referral.referral_programe) || "-"}</td>
                    <td>
                      <div
                        className={`status ${
                          referral.referral_status === "submitted"
                            ? "Submitted"
                            : referral.referral_status === "pending"
                            ? "Pending"
                            : referral.referral_status === "approved"
                            ? "Approved"
                            : referral.referral_status === "denied"
                            ? "Denied"
                            : ""
                        }`}
                      >
                        {capitalizeName(referral?.referral_status) || "-"}
                      </div>
                    </td>
                    <td>{referral?.created_at || "N/A"}</td>
                    <td>
                      <Tooltip title="History">
                        <Scroll
                          size={24}
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(`/referrals/${referral.member.id}`);
                            localStorage.setItem(
                              "member",
                              JSON.stringify(referral?.member)
                            );
                          }}
                        />
                      </Tooltip>{" "}
                      <Tooltip title="Edit">
                        <Pencil
                          size={24}
                          className="cursor-pointer ms-3"
                          onClick={() => {
                            setSelectedReferral(referral);
                            handleOpenAddModad();
                          }}
                        />
                      </Tooltip>{" "}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TableWrapper>

      {isreferralAddModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseAddModal}
          heading={`Referrals`}
        >
          <AddReferralsList
            handleOpenNewReferralForm={handleOpenAddReferralModal}
            handleCloseAddModal={handleCloseAddModal}
            selectedReferral={selectedReferral}
            setSelectedReferral={setSelectedReferral}
            handleRefreshPage={handleRefreshPage}
          />
        </CustomModal>
      )}

      {FilterReferrals && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseFilterReferral}
          heading={`Filter Referrals`}
        >
          <FilterReferral
            handleSubmittion={handleApplyFilters}
            handleClose={handleCloseFilterReferral}
            currentFilters={filters}
          />
        </CustomModal>
      )}
      {addNewMemberModal && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseAddMemberModal}
          heading={`Add Referral`}
        >
          <AddFormWithoutMember
            handleSubmitForm={handleAddNewMember}
            handleClose={handleCloseAddMemberModal}
          />
          {/* <AddQuestionForm
            handleClose={handleCloseAddMemberModal}
            handleQuestionSubmittion={handleAddNewMember}
          /> */}
        </CustomModal>
      )}
    </>
  );
};

export default ReferralsList;
